export default __webpack_public_path__ + "static/media/bg.d188d6a5.jpg";